export default __webpack_public_path__ + "static/media/ic_mvlp_24.da5bbbce.svg";